export default __webpack_public_path__ + "static/media/DDC_Uchen.9752bec2.ttf";